module.exports = __webpack_public_path__ + "img/mutenmaru.3f2ff4da.png";